import { createComponent } from '@lib/util/templateHelpers';

import styles from './index.module.scss';
import IoGameTile from '@/components/IoGameTile';

export default createComponent('CallToActionTile', { styles }, function CallToActionTile ({ className }, props) {
  return (
    <div className={className}>
      <IoGameTile game={props.game} />
      {/* <span className='CallToActionTile__Label'>{props.children}</span> */}
    </div>
  );
});
